export const ACK_ADD_CONTEXT = 'ACK_ADD_CONTEXT';
export const ACK_RECEIVE_MESSAGE = 'ACK_RECEIVE_MESSAGE';
export const ACK_DELETE = 'ACK_DELETE';
